export enum GraphAxiesEnum {
  averagePositon = 'Средняя позиция',
  sop = 'Доля позиций в %',
  soi = 'Видимость на странице в %',
  date = 'Дата',
}

export enum GraphNameEnum {
  sop = 'Доля позиций на странице',
  soi = 'Видимость на странице',
  averagePositon = 'Средняя позиция',
}

export enum TableNameEnum {
  brand = 'Бренд',
  averagePositon = 'Средняя позиция',
  averagePositions = 'Среднее кол-во позиций',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  averageProducts = 'Среднее кол-во позиций',
  soi = 'Видимость в %',
  sos = 'Доля позиции в %',
}
